export default function IconQuote({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M11.0653 4.53941C5.44059 7.4998 3.42753 13.5982 5.79584 13.5982H6.15109C8.10495 13.5982 9.64436 15.3152 9.64436 17.2691C9.64436 19.2822 7.80891 20.94 5.85505 20.94C2.83545 20.94 1 18.0388 1 15.1968C1 10.1642 3.66436 5.9604 10.2364 3L11.0653 4.53941ZM12.8416 15.1968C12.8416 10.1642 15.5059 5.9604 22.078 3L22.9069 4.53941C17.2822 7.4998 15.2691 13.5982 17.6374 13.5982H17.9927C19.9465 13.5982 21.4859 15.3152 21.4859 17.2691C21.4859 19.2822 19.6505 20.94 17.6966 20.94C14.677 20.94 12.8416 18.0388 12.8416 15.1968Z"
        fill="currentColor"
      />
    </svg>
  );
}
